import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter11 extends Component {
  static displayName = Chapter11.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—11: ज्ञान-प्रकाश : वाणी जो अंधकार को चीर दे 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                स्वामी ब्रह्मानंद सरस्वती जी महाराज का जीवन केवल तप, साधना और त्याग तक सीमित नहीं था। उनकी असली पहचान उनके ज्ञान-प्रकाश, दिव्य वाणी, और जीवन-परिवर्तनकारी उपदेशों में थी। उनके शब्द किसी भाषण की तरह नहीं होते थे— वे अनुभव की गहराई से निकली साक्षात् चेतना होते थे। उनकी वाणी सुनकर लोग कहते थे— “यह शब्द नहीं, ईश्वर का संदेश है।”
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            {/* <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>श्मशान में की गई उनकी कठोर तपस्या।</h3> */}
            
            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>1. मौन में जन्मा ज्ञान</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव का ज्ञान पुस्तकों या बहसों से नहीं आया। वह आया था— पहाड़ों की गुफाओं से, श्मशान की रातों से, नदी की शांति से, ऋषियों के आशीर्वाद से और वर्षों की अकथनीय तपस्या से इसलिए उनकी वाणी में वही प्रकृति का मौन, वही सत्य की सादगी, और वही आत्मा की गहराई थी। वे कहते थे— “जिस ज्ञान का जन्म मौन में नहीं, वह मन के कोलाहल में खो जाता है।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>2. धर्म — न कोई आडंबर, न कोई भय</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव धर्म का अत्यंत सरल परंतु अत्यंत गूढ़ स्वरूप बताते थे।
              वे कहा करते थे— “धर्म वह है, जो मन को शांत करे। जो अशांति दे, वह धर्म नहीं— भ्रम है।”
              उनके लिए धर्म— पूजा की विधि नहीं, जाति का गर्व नहीं, बाहरी भेष नहीं।
            धर्म = सत्य, शांति, करुणा और नैतिकता। एक बार एक युवक ने पूछा— “गुरुदेव, धर्म में सबसे महत्वपूर्ण क्या है?” गुरुदेव ने कहा— “मन की पवित्रता।” फिर बोले— “यदि मन शुद्ध है, तो ईश्वर पास है। यदि मन अशुद्ध है, तो ईश्वर दूर।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>3. समाज के लिए संदेश — शक्ति, सेवा और संतुलन</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव समाज में संतुलन चाहते थे— न अत्यधिक त्याग, न अत्यधिक भोग। वे कहते— “घर में रहकर भी संत हुआ जा सकता है, यदि मन लोभ से मुक्त हो।” वे प्रत्येक मनुष्य में असीम शक्ति देखते थे। उनका वचन था— “मनुष्य कमजोर नहीं है। वह अपनी शक्ति पहचानता नहीं है।” गुरुदेव लोगों से कहते— झूठ मत बोलो, किसी का हक मत मारो, अपने कर्म शुद्ध रखो और दिन में कम से कम कुछ क्षण ‘अपने भीतर’ जाओ क्योंकि— “बाहर दौड़ते-दौड़ते मन नष्ट हो जाता है। भीतर जाते-जाते मन परमशांति पाता है।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>4. शिक्षित समाज से अपेक्षा</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव शिक्षित युवाओं को राष्ट्र की रीढ़ मानते थे। उनका संदेश— “शिक्षा जो विनम्रता न दे, वह अहंकार बढ़ाती है। शिक्षा जो सेवा न दे, वह भार बन जाती है।” उनकी दृष्टि में— सच्चा विद्यार्थी = जिसके भीतर ज्ञान के साथ संस्कार भी हों।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>5. गुरु-शक्ति का वास्तविक स्वरूप</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव कहते थे— “गुरु वह नहीं जो चमत्कार दिखाए, गुरु वह है जो अज्ञान दूर करे।” उनका मत था कि गुरु का कार्य केवल मार्ग दिखाना है— चलना शिष्य को ही पड़ता है। वे कहा करते थे— “साधना मैं नहीं करा सकता, मैं केवल दिशा दे सकता हूँ। मेहनत तुम्हारी होगी, कृपा भगवान की।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>6. भगवती बगलामुखी का संदेश — स्थिरता और निर्भयता</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव जीवनभर माँ बगलामुखी के उपासक रहे। इस उपासना का प्रभाव उनकी वाणी, उनकी दृढ़ता और उनके निर्णयों में स्पष्ट दिखता था। वे कहते— “भय मन का सबसे बड़ा रोग है। बगलामुखी की कृपा से भय नष्ट होता है और मन स्थिर हो जाता है।” उनका दृढ़ विश्वास था— “जिस मन में भय नहीं, उस मन को ईश्वर का प्रकाश स्वयं मार्ग दिखाता है।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>7. जीवन का सार — शांति, सेवा और समर्पण</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              अपने अंतिम दिनों में कई शिष्यों ने उनसे पूछा— “गुरुदेव, जीवन का सार क्या है?” उन्होंने मुस्कुराकर कहा— “जीवन का सार शांति है। शांति का सार सत्य है। और सत्य का सार— ईश्वर के चरणों में समर्पण।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>8. उनकी वाणी क्यों दिव्य मानी गई?</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              क्योंकि— वह अनुभव से निकली थी वह तपस्या से तपकर आई थी वह किसी सिद्धांत का बोझ नहीं, बल्कि ईश्वर का सशक्त स्पर्श था कई बार लोग कहते— “गुरुदेव बोलते नहीं थे, ईश्वर उनके माध्यम से बोलता था।” और यह अतिशयोक्ति नहीं थी— जिसने सुना, उसने महसूस किया।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>अध्याय का सार</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              अध्याय 11 यह बताता है कि— स्वामी ब्रह्मानंद सरस्वती जी महाराज केवल साधक नहीं थे, वे ज्ञान का उद्गम, शांति का स्रोत, और समाज के लिए धर्म का जीवित स्वरूप थे। उनकी वाणी केवल उस समय के लिए नहीं— आज भी उतनी ही प्रासंगिक, उतनी ही जीवंत और उतनी ही आलोकित है।
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter10" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter12" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}